import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// iter 215 (2026-02): admin 和 user_admin 都能访问用户管理页;其它路由
// (Settings, Access Tokens) 仍保留 admin-only。
export const UserMgmtRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Verifying session...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user?.role !== "admin" && user?.role !== "user_admin") return <Navigate to="/" replace />;
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Verifying session...</div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

// iter 277: CI reservation verification — admin or ci_admin role.
export const CiAdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  if (!["admin", "ci_admin"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

// iter 267: sample warehouse page — admin or sample_warehouse role.
export const SampleRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  if (!["admin", "sample_warehouse"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
